import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.devtools = true
Vue.config.productionTip = false
Vue.prototype.$axios = axios,


new Vue({


	VueAxios,
	vuetify,
	render: h => h(App)
  
}).$mount('#app')
